import React, {
  useEffect,
  useMemo,
  useState,
  useCallback
} from "react";

import axios from "axios";

import {

  Search,

  RefreshCw,

  CheckCircle2,

  XCircle,

  Calendar,

  Mail,

  Loader2

} from "lucide-react";

import "./PendingUploads.css";

const PendingUploads = () => {

  const [uploads, setUploads] = useState([]);

  const [loading, setLoading] = useState(true);

  const [refreshing, setRefreshing] = useState(false);

  const [processing, setProcessing] = useState("");

  const [search, setSearch] = useState("");

  const [typeFilter, setTypeFilter] = useState("all");

  const [remarks, setRemarks] = useState({});

  const fetchUploads = useCallback(async () => {

    try {

      setRefreshing(true);

      const res = await axios.get(

        "/api/admin/uploads/pending"

      );

      if (res.data.success) {

        setUploads(

          res.data.uploads || []

        );

      }

    }

    catch (err) {

      console.error(err);

      alert(

        err.response?.data?.message ||

        "Failed to fetch uploads."

      );

    }

    finally {

      setLoading(false);

      setRefreshing(false);

    }

  }, []);

  useEffect(() => {

    fetchUploads();

  }, [fetchUploads]);

  /* =====================================
      APPROVE
  ===================================== */

  const approveUpload = async (upload) => {

    const ok = window.confirm(

      "Approve this upload?"

    );

    if (!ok) return;

    try {

      setProcessing(upload._id);

      const res = await axios.put(

        "/api/admin/uploads/approve",

        {

          uploadId: upload._id,

          adminName:

            localStorage.getItem(

              "user_name"

            ) || "Admin"

        }

      );

      alert(

        res.data.message ||

        "Upload Approved"

      );

      fetchUploads();

    }

    catch (err) {

      alert(

        err.response?.data?.message ||

        err.message

      );

    }

    finally {

      setProcessing("");

    }

  };

  /* =====================================
      REJECT
  ===================================== */

  const rejectUpload = async (upload) => {

    if (

      !remarks[upload._id]?.trim()

    ) {

      return alert(

        "Please enter rejection remarks."

      );

    }

    const ok = window.confirm(

      "Reject this upload?"

    );

    if (!ok) return;

    try {

      setProcessing(upload._id);

      const res = await axios.put(

        "/api/admin/uploads/reject",

        {

          uploadId: upload._id,

          remarks:

            remarks[upload._id],

          adminName:

            localStorage.getItem(

              "user_name"

            ) || "Admin"

        }

      );

      alert(

        res.data.message ||

        "Upload Rejected"

      );

      fetchUploads();

    }

    catch (err) {

      alert(

        err.response?.data?.message ||

        err.message

      );

    }

    finally {

      setProcessing("");

    }

  };

  /* =====================================
      FILTER
  ===================================== */

  const filteredUploads = useMemo(() => {

    return uploads.filter((upload) => {

      const keyword =

        search.toLowerCase();

      const searchMatch =

        upload.email

          ?.toLowerCase()

          .includes(keyword);

      const typeMatch =

        typeFilter === "all" ||

        upload.type === typeFilter;

      return searchMatch && typeMatch;

    });

  }, [

    uploads,

    search,

    typeFilter

  ]);

  /* =====================================
      FORMAT TYPE
  ===================================== */

  const formatType = (type) => {

    switch (type) {

      case "hammer_dominant":

        return "Hammer 150 (Dominant)";

      case "hammer_non_dominant":

        return "Hammer 150 (Non Dominant)";

      case "story":

        return "Real Life Story";

      case "sleep":

        return "Sleep Tracking";

      default:

        return type;

    }

  };
  return (

  <div className="pending-page">

    <div className="pending-header">

      <div>

        <h2>

          Pending Upload Verification

        </h2>

        <p>

          Review and verify uploaded videos.

        </p>

      </div>

      <button

        className="refresh-btn"

        onClick={fetchUploads}

        disabled={refreshing}

      >

        {

          refreshing ?

          <Loader2

            size={18}

            className="spin"

          />

          :

          <RefreshCw size={18} />

        }

        {

          refreshing ?

          "Refreshing..."

          :

          "Refresh"

        }

      </button>

    </div>

    <div className="pending-filters">

      <div className="search-box">

        <Search size={18} />

        <input

          type="text"

          placeholder="Search by email..."

          value={search}

          onChange={(e)=>

            setSearch(e.target.value)

          }

        />

      </div>

      <select

        value={typeFilter}

        onChange={(e)=>

          setTypeFilter(

            e.target.value

          )

        }

      >

        <option value="all">

          All Upload Types

        </option>

        <option value="hammer_dominant">

          Hammer Dominant

        </option>

        <option value="hammer_non_dominant">

          Hammer Non Dominant

        </option>

        <option value="story">

          Real Life Story

        </option>

        <option value="sleep">

          Sleep Tracking

        </option>

      </select>

    </div>

    {

      loading ?

      (

        <div className="empty-state">

          <Loader2

            className="spin"

            size={40}

          />

          <p>

            Loading uploads...

          </p>

        </div>

      )

      :

      filteredUploads.length === 0 ?

      (

        <div className="empty-state">

          <h3>

            No Pending Uploads

          </h3>

          <p>

            Everything is verified.

          </p>

        </div>

      )

      :

      (

        <div className="upload-grid">

          {

            filteredUploads.map(

              (upload)=>(

                <div

                  key={upload._id}

                  className="upload-card"

                >

                  <div className="card-top">

                    <span className="status pending">

                      Pending

                    </span>

                    <span>

                      {

                        formatType(

                          upload.type

                        )

                      }

                    </span>

                  </div>

                  <div className="customer-info">

                    <div>

                      <Mail size={16} />

                      <span>

                        {upload.email}

                      </span>

                    </div>

                    <div>

                      <Calendar size={16} />

                      <span>

                        {

                          new Date(

                            upload.createdAt

                          ).toLocaleString()

                        }

                      </span>

                    </div>

                  </div>

                  <div className="video-wrapper">

                    <video

                      controls

                      preload="metadata"

                      className="video-player"

                    >

                      <source

                        src={upload.fileUrl}

                        type="video/mp4"

                      />

                      Your browser does not support video.

                    </video>

                  </div>

                  <textarea

                    placeholder="Enter rejection remarks..."

                    value={

                      remarks[upload._id] ||

                      ""

                    }

                    onChange={(e)=>

                      setRemarks({

                        ...remarks,

                        [upload._id]:

                        e.target.value

                      })

                    }

                  />

                  <div className="card-actions">

                    <button

                      className="approve-btn"

                      disabled={

                        processing ===

                        upload._id

                      }

                      onClick={()=>

                        approveUpload(

                          upload

                        )

                      }

                    >

                      {

                        processing ===

                        upload._id ?

                        (

                          <Loader2

                            size={18}

                            className="spin"

                          />

                        )

                        :

                        (

                          <CheckCircle2

                            size={18}

                          />

                        )

                      }

                      Approve

                    </button>

                    <button

                      className="reject-btn"

                      disabled={

                        processing ===

                        upload._id

                      }

                      onClick={()=>

                        rejectUpload(

                          upload

                        )

                      }

                    >

                      {

                        processing ===

                        upload._id ?

                        (

                          <Loader2

                            size={18}

                            className="spin"

                          />

                        )

                        :

                        (

                          <XCircle

                            size={18}

                          />

                        )

                      }

                      Reject

                    </button>

                  </div>

                </div>

              )

            )

          }

        </div>

      )

    }

  </div>

);

};

export default PendingUploads;